import { render, staticRenderFns } from "./DeletedLecturers.vue?vue&type=template&id=cd77afe2"
import script from "./DeletedLecturers.vue?vue&type=script&lang=js"
export * from "./DeletedLecturers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports